import Cookies from 'js-cookie'

const mapAvailability = ({
  id_availability: availabilityId,
  selling_rate: sellingRate,
  bighead_rate: bighead,
  pay_rate: payRate,
  taxes,
  summary,
}) => ({
  availabilityId,
  sellingRate,
  bighead,
  payRate,
  taxes,
  summary,
})

export function mapSummary(data) {
  const isPayNowEnabled =
    process.env.NEXT_PUBLIC_IS_PAY_NOW_ENABLED === 'true' || Cookies.get('isPayNow') === 'true'

  const newSummary = {
    ...(data.subtotal && { subtotal: data.subtotal }),
    ...(data.taxes && { taxes: data.taxes }),
    ...(data.availabilities && {
      availabilities: data.availabilities?.map(mapAvailability),
    }),
  }

  return {
    insurance: data.additional_products?.insurance || null,
    insuranceCurrency: data.currency || null,
    payLate: data.remaining_payment || null,
    payNow: data.pay_rate || null,
    staywallet: data.discounts?.staywallet || null,
    staywalletCurrency: data.currency || null,
    total: data.total || 0,
    totalCurrency: data.currency || null,
    totalWithFees: data.total_with_fees || null,
    totalWithFeesCurrency: data.currency || null,
    subtotalWithFees: data.subtotal_with_fees || null,
    subtotalNightlyWithFees: data.subtotal_nightly_with_fees || null,
    ...(isPayNowEnabled && newSummary),
    ...(data.additional_products && { additionalProducts: data.additional_products }),
  }
}
